/**
 * `/f/$link` — the driver's ticket on a phone (Forms slice F1, PRD 48 §6–§7,
 * D-298.7). Opened from the link at the end of the job text, with nobody
 * signed in: no shell, no company in the address. The company and the copy
 * come only from the link, through /api/public/forms/links/{secret}; an
 * unknown, expired or cancelled link gets one plain refusal.
 */

import { FormsPhoneScreen } from "@ken/module-forms";
import { createFileRoute, useParams } from "@tanstack/react-router";
import { Suspense, type ReactElement } from "react";

export const Route = createFileRoute("/f/$link")({
  component: PhoneTicketRoute,
});

function PhoneTicketRoute(): ReactElement {
  const { link } = useParams({ from: "/f/$link" });
  return (
    <Suspense fallback={null}>
      <FormsPhoneScreen secret={link} />
    </Suspense>
  );
}
